module.exports = __webpack_public_path__ + "img/facilities_05.1f9aabc4.jpg";